import { render, staticRenderFns } from "./BdTableList.vue?vue&type=template&id=9ad13002&scoped=true"
import script from "./BdTableList.vue?vue&type=script&lang=js"
export * from "./BdTableList.vue?vue&type=script&lang=js"
import style0 from "./BdTableList.vue?vue&type=style&index=0&id=9ad13002&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad13002",
  null
  
)

export default component.exports